import { render, staticRenderFns } from "./FinanceSwitchboard.vue?vue&type=template&id=5d2c8f86"
import script from "./FinanceSwitchboard.vue?vue&type=script&lang=js"
export * from "./FinanceSwitchboard.vue?vue&type=script&lang=js"
import style0 from "./FinanceSwitchboard.vue?vue&type=style&index=0&id=5d2c8f86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports